document.querySelectorAll('.js-home-features-carousel').forEach(function (carousel) {
  if (!carousel.classList.contains('is-splide-initialized')) {
    carousel.classList.add('splide', 'is-splide-initialized');

    var splide = new Splide(carousel, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      pagination: true,
      arrows: true,
      rewind: false,
      breakpoints: {
        1499: { perPage: 3 },
        1199: { perPage: 3 },
        991: { perPage: 2 },
        767: { perPage: 1 }
      }
    });

    splide.on('mounted', function () {
      if (splide.Components.Controller.getEnd() === 0) {
        var pagination = carousel.querySelector('.splide__pagination');
        if (pagination) {
          pagination.style.display = 'none';
        }
      }
    });

    splide.mount();
  }
});

document.querySelectorAll('.js-home-modern-features-carousel').forEach(function (carousel) {
  if (!carousel.classList.contains('is-splide-initialized')) {
    carousel.classList.add('splide', 'is-splide-initialized');

    var splide = new Splide(carousel, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      pagination: true,
      arrows: true,
      rewind: false,
      breakpoints: {
        1499: { perPage: 3 },
        1199: { perPage: 3 },
        991: { perPage: 2 },
        767: { perPage: 1 }
      }
    });

    splide.on('mounted', function () {
      if (splide.Components.Controller.getEnd() === 0) {
        var pagination = carousel.querySelector('.splide__pagination');
        if (pagination) {
          pagination.style.display = 'none';
        }
      }
    });

    splide.mount();
  }
});